<template>
    <div>
        <vs-row>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <h5 class="p-2 pb-3">Safety Program Reports</h5>
                <vx-card class="no-effect">
                    <div slot="no-body">
                        <vs-list slot="no-body" class="p-0">
                            <router-link v-if="hasAccess('read', `safety_program_report`, 'all')" :to="{name: 'safety-program-report-list'}" class="text-black">
                                <vs-list-item title="Safety Program" subtitle="Click to see reports" class="itm-bx"></vs-list-item>
                            </router-link>
                            <router-link v-if="hasAccess('read', `issue_hazard_report`, 'all')" :to="{name: 'issues-report-list', params: {issue_type: 'hazard'}}" class="text-black">
                                <vs-list-item title="Hazard Accidents" subtitle="Click to see hazard reports" class="itm-bx"></vs-list-item>
                            </router-link>
                        </vs-list>
                    </div>
                </vx-card>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
        }
    },
}
</script>
